import { useRef, useState, useEffect } from "react";

import { useForgotPasswordMutation } from "./authApiSlice";

//import { yellow } from "@mui/material/colors";
//import HighlightIcon from "@mui/icons-material/Highlight";
import { ReactComponent as MarkNotesIcon } from "../../logo.svg";
import {
  TextField,
  CircularProgress,
  Alert,
  AlertTitle,
  Stack,
} from "@mui/material";

//const color = yellow[500];
function ForgotPassword() {
  //change it to email and use one state to handle all on change
  const userRef = useRef();
  const [userEmail, setUserEmail] = useState("");

  const [forgotPw, { isLoading, isSuccess, isError, error, reset }] =
    useForgotPasswordMutation();

  useEffect(() => {
    userRef.current.focus(); //when it renders, focus directly in that username field
  }, []);
  useEffect(() => {
    if (isSuccess) {
      setUserEmail("");
      //reset();
    }
  }, [userEmail, isSuccess, reset]);

  async function handleSubmit(e) {
    e.preventDefault();
    await forgotPw(userEmail);
  }
  const errClass = isError ? "errmsg" : "offscreen";
  //use icon here
  if (isLoading)
    return (
      <Stack alignItems="center" spacing={5}>
        <CircularProgress />
      </Stack>
    );
  if (isSuccess) {
    return (
      <div>
        <header className="forgot-password-header">
          <MarkNotesIcon />
          <h1>Forgot Password</h1>
        </header>
        <Alert
          variant="filled"
          severity="success"
          sx={{
            p: "35px",
            width: "35%",
          }}
        >
          <AlertTitle>Reset Password email sent</AlertTitle>
          You should soon receive an email allowing you to reset your password.
          <strong>
            Please make sure to check your spam and trash if you can't find the
            email.
          </strong>
        </Alert>
      </div>
    );
  }
  return (
    <section>
      <main>
        <header className="forgot-password-header">
          <MarkNotesIcon />
          <h1>Forgot Password</h1>
        </header>
        <form className="forgot-password" onSubmit={handleSubmit}>
          <TextField
            type="email"
            label="Email"
            name="userEmail"
            ref={userRef}
            value={userEmail}
            fullWidth
            onChange={(e) => {
              setUserEmail(e.target.value);
            }}
            autoComplete="off"
            required
          />
          <button className="form-submit-btn">Send Password Reset Email</button>
          <p className={errClass}>{error?.data?.message}</p>
        </form>
      </main>
    </section>
  );
}

export default ForgotPassword;
